module.exports = __webpack_public_path__ + "img/3.85087654.png";